import {
  IconButton,
  IconButtonIcon
} from "../chunk-EG46MEUM.js";
import "../chunk-SRTWNKEZ.js";
import {
  cx
} from "../chunk-RLQEQISX.js";

// src/components/dialog.tsx
import { Cross1Icon } from "@radix-ui/react-icons";
import { Slot } from "@radix-ui/react-slot";
import { forwardRef, useContext } from "react";
import {
  Button as ButtonPrimitive,
  Dialog as DialogPrimitive,
  Heading as HeadingPrimitive,
  Modal as ModalPrimitive,
  ModalOverlay as ModalOverlayPrimitive,
  OverlayTriggerStateContext
} from "react-aria-components";
import { DialogTrigger } from "react-aria-components";
import { jsx } from "react/jsx-runtime";
var DialogModalOverlay = forwardRef(({ className, ...properties }, reference) => {
  const mergedClassName = cx(
    "before:exiting:animate-out before:exiting:fade-out before:exiting:duration-200 before:exiting:ease-in before:entering:animate-in before:entering:fade-in before:entering:duration-200 before:entering:ease-out before:bg-black-a-6 before:dark:bg-black-a-8 fixed inset-0 grid min-h-full w-screen grid-rows-[1fr_auto] justify-items-center overflow-y-auto p-4 pt-6 before:pointer-events-none before:fixed before:inset-0 before:backdrop-blur before:content-[''] sm:grid-rows-[1fr_auto_3fr]",
    className
  );
  return /* @__PURE__ */ jsx(ModalOverlayPrimitive, { className: mergedClassName, ...properties, ref: reference });
});
DialogModalOverlay.displayName = "DialogModalOverlay";
var DialogModal = forwardRef(({ className, ...properties }, reference) => {
  const mergedClassName = cx(
    "entering:fade-in exiting:fade-out exiting:animate-out exiting:slide-out-from-top-4 exiting:sm:slide-out-from-top-0 exiting:sm:zoom-out-95 exiting:ease-in exiting:duration-100 entering:animate-in entering:sm:zoom-in-95 entering:slide-in-from-bottom-4 entering:sm:slide-in-from-bottom-0 entering:ease-out entering:duration-200 row-start-2",
    className
  );
  return /* @__PURE__ */ jsx(ModalPrimitive, { className: mergedClassName, ...properties, ref: reference });
});
DialogModal.displayName = "DialogModal";
var Dialog = forwardRef(({ className, ...properties }, reference) => {
  const mergedClassName = cx(
    "dark:bg-neutral-2 outline-neutral-6 relative w-full min-w-0 rounded-2xl bg-white shadow-lg outline-none outline-1 -outline-offset-1 transition duration-100 will-change-transform sm:mb-auto sm:max-w-xl dark:outline",
    className
  );
  return /* @__PURE__ */ jsx(DialogPrimitive, { className: mergedClassName, ...properties, ref: reference });
});
Dialog.displayName = "Dialog";
var DialogCloseButtonPrimitive = forwardRef(({ asChild = false, ...properties }, reference) => {
  const Component = asChild ? Slot : ButtonPrimitive;
  const { close } = useContext(OverlayTriggerStateContext);
  return /* @__PURE__ */ jsx(Component, { onPress: close, ...properties, ref: reference });
});
DialogCloseButtonPrimitive.displayName = "DialogCloseButtonPrimitive";
var DialogCloseIconButton = forwardRef(({ className, variant = "ghost", ...properties }, reference) => {
  const mergedClassName = cx("absolute end-3 top-3 hidden size-7 sm:block", className);
  const { close } = useContext(OverlayTriggerStateContext);
  return /* @__PURE__ */ jsx(
    IconButton,
    {
      className: mergedClassName,
      onPress: close,
      variant,
      ...properties,
      ref: reference
    }
  );
});
DialogCloseIconButton.displayName = "DialogCloseIconButton";
var DialogCloseIconButtonIcon = forwardRef((properties, reference) => /* @__PURE__ */ jsx(IconButtonIcon, { "aria-hidden": true, asChild: true, ref: reference, ...properties, children: /* @__PURE__ */ jsx(Cross1Icon, {}) }));
DialogCloseIconButtonIcon.displayName = "DialogCloseIconButtonIcon";
var DialogTitle = forwardRef(({ className, ...properties }, reference) => {
  const mergedClassName = cx("text-neutral-12 text-base font-semibold leading-6 rtl:text-right", className);
  return /* @__PURE__ */ jsx(HeadingPrimitive, { className: mergedClassName, slot: "title", ...properties, ref: reference });
});
DialogTitle.displayName = "DialogTitle";
export {
  Dialog,
  DialogCloseButtonPrimitive,
  DialogCloseIconButton,
  DialogCloseIconButtonIcon,
  DialogModal,
  DialogModalOverlay,
  DialogTitle,
  DialogTrigger
};
